export const inputStyles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: '#1E1E1E',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #2D2D2D',
  },
  // ... other input-related styles
}; 